import { Button } from '@material-ui/core';
import { Theme, withStyles } from '@material-ui/core/styles';

const FinishBookingButton = withStyles((theme: Theme) => ({
  root: {
    background: theme.palette.secondary.main,
    color: theme.palette.grey[900],
    padding: theme.spacing(0.5, 2),
    '&:hover': {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.grey[700],
    },
    '&$focused': {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.grey[700],
    },
  },
  label: {
    textTransform: 'capitalize',
  },
}))(Button);

export default FinishBookingButton;